// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';

export default class NotificationView extends JQueryView {
  constructor() {
    super('.notification');

    $('.notification .dropdown-item, .notification .dropdown-header').click(
      'click',
      event => {
        if (!$(event.target).hasClass('setting')) {
          event.stopPropagation();
        }
      },
    );

    $('#notifications .dropdown-item').each((_index, elem) => {
      const text = $(elem)
        .find('div > span')
        .text();
      if (text.length > 40) {
        const trimed_text = $.trim(text).substring(0, 40) + '...';
        $(elem)
          .find('div > span')
          .text(trimed_text);
      }
    });

    // タブ操作
    // ドロップダウンリスト上にタブが存在する関係でタブクリック後にリストが閉じるのを防ぐ必要があるため、
    // bootstrapのタブ機能は敢えて使っていない
    $('#notification-newsletter-tabs .nav-item').on('click', function(event) {
      const tabType = $(this).data('type');
      const scrollField = $(this)
        .parent()
        .next();
      const header = $(this)
        .parent()
        .parent()
        .find('.notification-header');
      scrollField.removeClass('longer-scroll-field shorter-scroll-field');
      header.find('.mark-all-read').removeClass('active');
      $('#notification-newsletter-tabs .nav-item').removeClass('active');
      $('#notification-newsletter-contents .tab-pane').removeClass('active');
      $('#all-newsletters').removeClass('active');
      $(this).addClass('active');

      if (tabType === 'notifications') {
        scrollField.addClass('longer-scroll-field');
        header.find('#all-read-notifications').addClass('active');
        $('#notifications').addClass('active');
      } else if (tabType === 'newsletters') {
        scrollField.addClass('shorter-scroll-field');
        header.find('#all-read-newsletters').addClass('active');
        $('#newsletters').addClass('active');
        $('#all-newsletters').addClass('active');
      }
      event.stopPropagation();
    });
  }

  @on({ event: 'click', selector: '.setting' })
  buildModalBody() {
    $('.prepare-modal-body').addClass('modal-body');
  }

  @on({ event: 'click', selector: '#all-read-notifications' })
  onClickMarkAllReadNotifications(event: any) {
    const $unread_notification_elems = $(
      '#notifications .dropdown-item.unread',
    );
    const unread_ids = $unread_notification_elems
      .map((_index, elem) => {
        return $(elem).data('notificationId');
      })
      .toArray();

    $.ajax({
      url: $(event.target).data('action'),
      type: 'POST',
      dataType: 'json',
      data: { notification_ids: unread_ids },
    })
      .done(() => {
        $unread_notification_elems.map((_index, elem) => {
          this.removeUnreadCircle(elem);
        });
        $('.notification .badge').remove();
      })
      .fail(() => {
        alert('既読にできませんでした');
      });
    event.stopPropagation();
  }

  @on({ event: 'click', selector: '#all-read-newsletters' })
  onClickMarkAllReadNewsletters(event: any) {
    const $unread_newsletter_elems = $('#newsletters .dropdown-item.unread');
    const unread_ids = $unread_newsletter_elems
      .map((_index, elem) => {
        return $(elem).data('userNewsletterId');
      })
      .toArray();

    $.ajax({
      url: $(event.target).data('action'),
      type: 'POST',
      dataType: 'json',
      data: { user_newsletter_ids: unread_ids },
    })
      .done(() => {
        $unread_newsletter_elems.map((_index, elem) => {
          this.removeUnreadCircle(elem);
        });
      })
      .fail(() => {
        alert('既読にできませんでした');
      });
    event.stopPropagation();
  }

  removeUnreadCircle(element: any) {
    $(element).removeClass('unread');
    $(element).addClass('read');
    $(element)
      .find('.unread-circle')
      .removeClass('visible');
    $(element)
      .find('.unread-circle')
      .addClass('invisible');
  }
}
